/**
 * Information Modal
 */

// React
import React, { FC } from 'react';

// Material
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

// Mock Data
import { DataSystemApplicationSetting } from 'utils/types';

// Utils
import { getIconUrl } from 'utils/helper/common';

// Styled
export const Icon = styled('img')({
  width: '80px',
  height: 'auto',
});

export const WrapperContent = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '20px',
});

export const TypographyCustom = styled(Typography)({
  color: '#666666',
  fontWeight: '500',
});

export const ContainerContent = styled(Stack)({
  padding: '10px 0 0 15px',
});

interface InformationModalProps {
  data: DataSystemApplicationSetting | undefined;
}

// Component
const InformationModal: FC<InformationModalProps> = ({ data }) => {
  if (!data) return null;
  return (
    <ContainerContent spacing="32px">
      <Stack spacing="20px">
        <TypographyCustom>アイコン（ホーム画面）</TypographyCustom>
        <WrapperContent>
          <Icon src={getIconUrl(data?.icon)} alt="icon service" />
          <Typography variant="h2" color={data?.color}>
            {data?.title}
          </Typography>
        </WrapperContent>
      </Stack>
      <Stack spacing="20px">
        <TypographyCustom>アイコン（AF管理画面（利用中））</TypographyCustom>
        <WrapperContent>
          <Icon src={getIconUrl(data?.icon_status_active)} alt="icon service" />
        </WrapperContent>
      </Stack>
      <Stack spacing="20px">
        {' '}
        <TypographyCustom>アイコン（AF管理画面（申請中））</TypographyCustom>
        <WrapperContent>
          <Icon src={getIconUrl(data?.icon_status_deactive)} alt="icon service" />
        </WrapperContent>
      </Stack>
    </ContainerContent>
  );
};

export default InformationModal;
